import Typography from "../../../../ui/widgets/typography";
import { Grid } from "@mui/material";
import AddressSelect from "../../../shared/components/address-select";
import CountryFieldContainer from "../../../../ui/layout/page/forms-container/form-item-container/country-field-container";
import Country from "../../../shared/components/country";
import React, { useContext, useState } from "react";
import { CardholderFormProps } from "../types";
import { ScdAccordion } from "../../../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../../../ui/widgets/accordion/details";
import get from "lodash.get";
import { CardholderFormikContext } from "../../context";
import { useMessageSource } from "react-message-source";

interface AddressAccordionProps {
  fullStreet: CardholderFormProps["fullStreet"];
  address: CardholderFormProps["address"];
  dataPath: string;
}

export const AddressAccordion = ({
  address,
  dataPath,
  fullStreet,
}: AddressAccordionProps) => {
  const { errors, touched, values } = useContext(CardholderFormikContext);
  const { getMessage: t } = useMessageSource();

  const [isAccordionExpanded, setIsAccordionExpanded] = useState<boolean>(
    () => {
      const cityHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}address.city`) &&
          get(touched, `${dataPath}address.city`)) ||
        !get(values, `${dataPath}address.city`);

      const zipCodeHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}address.zipCode`) &&
          get(touched, `${dataPath}address.zipCode`)) ||
        !get(values, `${dataPath}address.zipCode`);

      const streetHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}address.street`) &&
          get(touched, `${dataPath}address.street`)) ||
        !get(values, `${dataPath}address.street`);

      const isAccordionExpandedFlag =
        cityHasErrorsAndTouchedAndEmpty ||
        zipCodeHasErrorsAndTouchedAndEmpty ||
        streetHasErrorsAndTouchedAndEmpty;

      return Boolean(isAccordionExpandedFlag);
    },
  );

  const handleAccordionChange = (
    _: React.SyntheticEvent,
    isExpanded: boolean,
  ) => {
    setIsAccordionExpanded(isExpanded);
  };

  return (
    <ScdAccordion
      expanded={isAccordionExpanded}
      onChange={handleAccordionChange}
    >
      <ScdAccordionSummary>
        <Typography variant="body2">{t("Address")}</Typography>
      </ScdAccordionSummary>
      <ScdAccordionDetails>
        <Grid className="scd-container-base" container>
          <AddressSelect
            fullStreet={fullStreet}
            address={address}
            dataPath={dataPath}
          />
          <CountryFieldContainer>
            <Country dataPath={dataPath} value={address.country} />
          </CountryFieldContainer>
        </Grid>
      </ScdAccordionDetails>
    </ScdAccordion>
  );
};
